import { useTranslation } from "react-i18next";

import { AccordionItem } from "../accordion/AccordionItem";

export const WhatIsAdvisory = () => {
  const { t } = useTranslation();

  return (
    <AccordionItem
      titleStyling="tw-font-normal tw-text-md"
      title={t("advice.manual.whatIsAdvisory.title")}
    >
      <div className="tw-text-sm">
        <p className="tw-text-sm">
          {t("advice.manual.whatIsAdvisory.description")}
        </p>
        <ul className="tw-list-inside tw-list-disc">
          <li>{t("advice.manual.whatIsAdvisory.list.item1")}</li>
          <li>{t("advice.manual.whatIsAdvisory.list.item2")}</li>
        </ul>
      </div>
    </AccordionItem>
  );
};
